import {BANK_ACCOUNT} from "../pharmacyTypeDefs";
import {useQuery} from "@apollo/client";

export const useQueryBankAccount = (options?: any): any => (
  useQuery(BANK_ACCOUNT, options)
);
